// extracted by mini-css-extract-plugin
export default {"root":"AssetVideoPlayer_root__5rnXP"};